// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.draft-badge {
    color: orange;
    margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/blog/pages/BlogAdminDashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;AACrB","sourcesContent":[".draft-badge {\n    color: orange;\n    margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
